import React from 'react';
import { Tooltip } from 'antd';
import {
  CloseCircleOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import './OrganizationStatusIndicator.less';
import { OrgCredential, OrgStatus } from '../../interfaces/organization';

type StatusConfig = {
  icon: React.ComponentType<{ className?: string }>;
  className: string;
  tooltip: string;
};

const STATUS_CONFIG: Record<OrgStatus | 'default', StatusConfig> = {
  [OrgStatus.ACTIVE]: {
    icon: CheckCircleOutlined,
    className: 'active',
    tooltip: 'Salesforce Organization is active',
  },
  [OrgStatus.EXPIRED]: {
    icon: SyncOutlined,
    className: 'expired',
    tooltip: 'Salesforce authorization has expired',
  },
  [OrgStatus.DELETED]: {
    icon: CloseCircleOutlined,
    className: 'invalid',
    tooltip: 'Salesforce Organization is no longer accessible',
  },
  [OrgStatus.INVALID]: {
    icon: CloseCircleOutlined,
    className: 'invalid',
    tooltip: 'Salesforce Organization is no longer accessible',
  },
  [OrgStatus.NEW]: {
    icon: ExclamationCircleOutlined,
    className: 'unknown',
    tooltip: 'Salesforce Organization status is unknown',
  },
  [OrgStatus.UNKNOWN]: {
    icon: ExclamationCircleOutlined,
    className: 'unknown',
    tooltip: 'Salesforce Organization status is unknown',
  },
  default: {
    icon: ExclamationCircleOutlined,
    className: 'unknown',
    tooltip: 'Salesforce Organization status is unknown',
  },
} as const;

interface OrganizationStatusIndicatorProps {
  cred: OrgCredential;
  tooltipOverride?: string;
  classNameOverride?: string;
}

const OrganizationStatusIndicator: React.FC<
  OrganizationStatusIndicatorProps
> = ({ cred, tooltipOverride, classNameOverride }) => {
  const {
    icon: Icon,
    className,
    tooltip,
  } = STATUS_CONFIG[cred.status] || STATUS_CONFIG.default;

  return (
    <Tooltip
      className="org-status-indicator-container"
      title={tooltipOverride ?? tooltip}
    >
      <span>
        <Icon className={`status-icon ${classNameOverride ?? className}`} />
      </span>
    </Tooltip>
  );
};

export default OrganizationStatusIndicator;
